<template>

    <v-dialog  v-model="dialog" width="450px" persistent>
        <template v-slot:activator="{ on, attrs }">
            <v-card flat class="fill-height">
                <v-card-text align="center" justify="center">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on">
                        view document
                    </v-btn>
                </v-card-text>
            </v-card>
        </template>
        <v-card>
            <v-toolbar dense color="primary" dark>
                Content viewer
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog=false">
                    <v-icon>
                        mdi-close
                    </v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text v-if="content!=null">
                <div class="pt-5 wysiwyg-content" v-html="content.contentText">
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            content: Object
        },
        data() {
            return {
                dialog: false
            }
        },
        methods: {
            open() {
                let self = this
                self.dialog = true
            },
        }

    }
</script>


<style scoped>
    .wysiwyg-content {
        width: 100%;
        overflow: hidden;
    }

    /* div {
        font-size: 18px;
        font-weight: 300;
        overflow-wrap: break-word;
        display: inline-block;
    } */
</style>